export default __webpack_public_path__ + "static/media/feedback_excellent_02.005b8047.png";